import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { DebugService } from '@dash/randy/shared/classes/debug.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalDataStorageService } from '@dash/randy/security/service/global-data-storage.service';

@Directive({
    selector: '[appAccessControlType]',
    standalone: false
})
export class AccessControlTypeDirective implements OnInit {
  destroyed$ = new Subject<boolean>();

  @Input() controlType: 'role' | 'permission' = 'role';

  constructor(private elementRef: ElementRef, private tokenStorageService: GlobalDataStorageService) {}

  ngOnInit(): void {
    const app = this.tokenStorageService.getSelectedApplication();
    if (!app) {
      return;
    }

    const accessControlType = app.accessControlType;

    if (this.controlType !== accessControlType) {
      this.elementRef.nativeElement.style.display = 'none';
    }
  }
}
